module.exports = "/_next/static/images/boston-fast-channel-description-image-black-letters-0f65e6bf9e2299bee00b5354edb914e8.svg";